import { render, staticRenderFns } from "./BrokerModal.vue?vue&type=template&id=acb71630"
import script from "./BrokerModal.vue?vue&type=script&lang=js"
export * from "./BrokerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports